<template>
  <div class="PuriContentsGimmi">
    <div class="sheets">
      <div class="sheet" v-for="(value, index) in uris" :key="index" :class="sampleImage[index]">
        <img v-lazy="value">
        <div v-if="hasgraffs[index] && !surpriseShot2s[index]" class="graffity" />
        <div v-if="surpriseShots[index] || surpriseShot2s[index]" class="surprise" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PuriContentsGimmi",
  props: {
    uris: {
      type: Array,
      require: true
    },
    selects: {
      type: Array,
      require: true
    },
    hasgraffs: {
      type: Array,
      require: true
    },
    surpriseShots: {
      type: Array,
      require: true
    },
    surpriseShot2s: {
      type: Array,
      require: true
    },
  },
  computed: {
    sampleImage() {
      return this.selects.map(selected => selected ? '' : 'sampleImage')
    }
  },
}
</script>

<style lang="scss" scoped>
.sheets {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-wrap: wrap;
}
.sheet {
  position: relative;
  width: calc((100% - 12px) / 4);
  height: 85px;
  margin-right: 4px;
  margin-bottom: 4px;
  &:nth-of-type(4n){
    margin-right: 0;
  }
  .graffity,
  .surprise {
    position: absolute;
    width: 21px;
    height: 21px;
    right: 1px;
    background-size: contain;
    z-index: 10;
  }
  .graffity {
    bottom: 1px;
    background-image: url(../assets/Png/Album/Album_Puri_Graffiti.png);
  }
  .surprise {
    top: 1px;
    background-image: url(../assets/Png/Album/Album_PuriMotto.png);
  }
}
.sampleImage {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    opacity: 1;
    filter: saturate(180%);
    background-image: url(../assets/Png/Common/puriSample.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
}
.sheet > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
